import { render } from "./DashboardMetricTrendsModal.vue?vue&type=template&id=4e976cd6"
import script from "./DashboardMetricTrendsModal.vue?vue&type=script&lang=js"
export * from "./DashboardMetricTrendsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__